/**
 * Build the annotation subject line for an approval action.
 *
 * The role used is encoded in plain English so a future Dataverse query
 * (or finance auditor) can read it without joining to anything.
 */
export function auditSubject(action, role) {
    const verb = action === "approved"
        ? "Approved"
        : action === "returned"
            ? "Returned"
            : action === "self-approved"
                ? "Self-approved"
                : "Self-returned";
    if (!role)
        return verb;
    switch (role) {
        case "Finance.Approver":
            return `${verb} (Finance Approver delegation)`;
        case "Operations.Manager":
            return `${verb} (Operations Manager delegation)`;
        case "Project.Manager":
            return `${verb} (Project Manager delegation)`;
        case "Admin":
            return `${verb} (Admin)`;
    }
}
